define(["require", "exports", "knockout", "../utils/dateUtils"], function (require, exports, ko, dateUtils) {
    "use strict";
    var CustomerBankingInfoModel = /** @class */ (function () {
        function CustomerBankingInfoModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.OfficeLocationId = ko.observable("");
            this.CardProvider = ko.observable();
            this.CardHolder = ko.observable();
            this.CardNumber = ko.observable();
            this.CardNumberPublic = ko.observable();
            this.CardSecurityCodeNumber = ko.observable();
            this.PublicNotes = ko.observable();
            this.PrivateNotes = ko.observable();
            this.ExpirationDate = ko.observable();
            this.BankAccountNumber = ko.observable();
            this.BankRoutingNumber = ko.observable();
            this.AddressLine1 = ko.observable();
            this.AddressLine2 = ko.observable();
            this.City = ko.observable();
            this.State = ko.observable();
            this.ZipCode = ko.observable();
            this.HasPublicNotes = ko.observable();
            this.HasPrivateNotes = ko.observable();
            this.ShowAllData = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerBankingInfoModel.Mapping, self);
            }
        }
        CustomerBankingInfoModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerBankingInfoModel(options.data);
            },
            ExpirationDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            }
        };
        return CustomerBankingInfoModel;
    }());
    return CustomerBankingInfoModel;
});
//# sourceMappingURL=CustomerBankingInfoModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerBankingInfoModel.js
// module id = 186
// module chunks = 2